export default {
  Comments: {
    Status: {
      NotApproved: 'بررسی نشده',
      Approved: 'تایید شده',
      Trashed: 'رد شده',
    },
    Action: {
      Answer: 'پاسخ',
      Reject: 'رد',
      Confirm: 'تایید',
    },
    Modal: {
      Confirm: 'آیا برای تایید این نظر مطمئن هستید؟',
      Reject: 'آیا برای رد این نظر مطمئن هستید؟',
      Answer: {
        Title: 'پاسخ به تیکت',
        Input: 'پاسخ',
      },
    },
    CreateFake: 'افزودن نظر ساختگی',
  },
}
